import PickupType from "../../enums/PickupType";
import Game from "../Game";
import GameCore from "../GameCore";
import BasePickup from "./BasePickup";
import PickupGroup from "./PickupGroup";
import {
  SPRITESHEET_KEYS,
  SPRITESHEET_FRAMES,
} from "../../consts/SPRITESHEETS";

export default class ApplePickup extends BasePickup {
  constructor(group: PickupGroup, x: number, y: number) {
    super(group, x, y, PickupType.APPLE, SPRITESHEET_KEYS.PICKUPS);
    this.setTexture(SPRITESHEET_KEYS.PICKUPS, SPRITESHEET_FRAMES.PICKUPS.APPLE);
    Game.Core.scene.add.existing(this);
    this.setScale(GameCore.PixelScale);
  }

  OnRecycle(): void {
    super.OnRecycle();
    this.setTexture(SPRITESHEET_KEYS.PICKUPS, SPRITESHEET_FRAMES.PICKUPS.APPLE);
  }

  Update() {
    super.Update();
    this.setDepth(9 + this.y - Game.Core.Player.y);
  }
  GetTaken() {
    // Play pickup sound using pooled audio (sound settings handled by facade)
    Game.Core.poolManager?.playAppleSound();

    Game.Core.Player.RecoverHp(this.value);
    Game.Core.Player.SetInvulForMilliSeconds(300);
    this.SetSeenItem(this.itemType);
    super.GetTaken();
  }
}
